<div class="container">
  <div class="container__title">
    <div class="title" translate>Coupon Code</div>
  </div>
  <div class="container__content">
    <div class="content">
      <div class="content__section content__section_input">
        <app-input
          type="text"
          name="couponId"
          [formControl]="couponIdControl"
          [error]="error"
        ></app-input>
      </div>
      <div class="content__section content__section_button">
        <app-button
          [disabled]="!orderId || couponIdControl.invalid || (coupon && !isCouponError)"
          (buttonClick)="redeemCoupon()"
        >{{ 'Apply' | translate }}</app-button>
      </div>
    </div>
  </div>
</div>
